export * from './app-sidebar-form.component';



// WEBPACK FOOTER //
// /home/fabiano/git/assinador-showcase/frontend/src/app/shared/layout/components/app-sidebar-form/index.ts